/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from 'react'
import {
  Button,
  Col,
  Container,
  Modal,
  Row,
  Table,
  Card
} from 'react-bootstrap'
import { useLocation, useNavigate } from 'react-router-dom'
import SelectInput from '../../components/Input/SelectInput'
import Loading from '../../components/atoms/Loading'
import toast, { Toaster } from 'react-hot-toast'
import ModalStockAdjustment from '../../components/modal/stockAdjustment/ModalStockAdjustment'
import api from '../../config/AxiosInstance'
import { capitalizeFirstLetter } from '../../helpers/constants'
import { dateFormat } from '../../utils/FormatDate'
import { Plus } from 'lucide-react'

const headerTitleStyle = {
  color: 'var(--primary-orange)',
  fontSize: '24px',
  fontWeight: '600'
}

const cardStyle = {
  border: 'none',
  boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
  borderRadius: '12px',
  padding: '1.5rem',
  marginBottom: '1.5rem',
  backgroundColor: '#fff'
}

const tableHeaderStyle = {
  fontSize: '14px',
  fontWeight: '600',
  color: '#333333',
  letterSpacing: '0.5px',
  backgroundColor: '#f8f9fa',
  borderBottom: '2px solid #e9ecef'
}

function StockOpnameCycleCountCreate() {
  const { state } = useLocation()
  const navigate = useNavigate()
  const [selectedRacks, setSelectedRacks] = useState([])
  const [options, setOptions] = useState({
    pics: [],
    checkers: []
  })
  const [selectedForm, setSelectedForm] = useState({
    pic: null,
    checker: null
  })
  const [loading, setLoading] = useState({
    page: false,
    submit: false
  })
  const [data, setData] = useState(null)
  const [showModal, setShowModal] = useState({
    submit: false,
    cancel: false,
    selectPicChecker: false
  })
  const handleChangeValue = (value, name, id) => {
    setData((prevData) =>
      prevData.map((item) =>
        item.id === id ? { ...item, [name]: value } : item
      )
    )
  }
  const handleCheckbox = (value = 'all') => {
    if (value === 'all') {
      const racks =
        data?.map((item) => {
          return {
            id: item?.id,
            rack_name: item?.name
          }
        }) || []
      if (racks?.length === selectedRacks?.length) {
        setSelectedRacks([])
      } else {
        setSelectedRacks(racks)
      }
    } else {
      if (selectedRacks?.find((item) => item?.id === value?.id)) {
        setSelectedRacks((prev) => prev.filter((item) => item.id !== value?.id))
      } else {
        setSelectedRacks((prev) => [
          ...prev,
          {
            id: value?.id,
            rack_name: value?.name
          }
        ])
      }
    }
  }
  const columns = [
    {
      key: 'checkbox',
      label: '',
      component: (value) => (
        <div key={value?.id} className="d-flex justify-content-center">
          <input
            type="checkbox"
            role="button"
            className="staging-area form-check-input"
            onChange={() => handleCheckbox(value)}
            style={{ cursor: 'pointer' }}
            checked={selectedRacks?.find((item) => item?.id === value?.id)}
          />
        </div>
      )
    },
    { key: 'name', label: 'Layer' },
    {
      key: 'type',
      label: 'Rack Type',
      component: (value) =>
        value?.type ? capitalizeFirstLetter(value.type) : '-'
    },
    { key: 'total_slot', label: 'Total Slot' },
    {
      key: 'checker',
      label: 'Checker',
      component: (value) => (
        <div key={value.id}>
          <SelectInput
            id={`${value.id}-checker`}
            handleChange={(e) =>
              handleChangeValue(e.target.value, 'checker_id', value.id)
            }
            options={
              state?.checkers?.map((checker) => ({
                value: checker.value,
                label: checker.label
              })) || []
            }
            value={value?.checker_id || ''}
          />
        </div>
      )
    },
    {
      key: 'pic',
      label: 'PIC',
      component: (value) => (
        <div key={value.id}>
          <SelectInput
            id={`${value.id}-pic`}
            handleChange={(e) =>
              handleChangeValue(e.target.value, 'pic_id', value.id)
            }
            options={
              state?.pics?.map((pic) => ({
                value: pic.value,
                label: pic.label
              })) || []
            }
            value={value?.pic_id || ''}
          />
        </div>
      )
    }
  ]
  const handleBack = () => {
    const {
      warehouse_id,
      start_time,
      end_time,
      pics,
      checkers,
      ...newStateValue
    } = state
    navigate('/stock-opname/cycle-count', {
      replace: true,
      state: newStateValue
    })
  }
  const handleSubmit = async () => {
    try {
      setLoading((prev) => ({ ...prev, submit: true }))
      const racks = data.map((item) => ({
        id: item?.id,
        rack: item?.name,
        checker_id: item?.checker_id,
        pic_id: item?.pic_id
      }))
      const payload = {
        warehouse_id: state?.warehouse_id,
        type: 'cycle_count',
        start_date: dateFormat(state?.start_time, 'YYYY-MM-DD HH:mm:ss'),
        end_date: dateFormat(state?.end_time, 'YYYY-MM-DD HH:mm:ss'),
        racks
      }
      const res = await api.post('/stock-opname', payload)
      const { data: dataResponse } = res
      if (dataResponse?.success) {
        toast.success('Cycle Count Created!', {
          position: 'top-right',
          style: {
            fontSize: '14px',
            fontWeight: '600'
          }
        })
        handleBack()
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.errors?.message ||
        error?.message ||
        'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    } finally {
      setTimeout(() => {
        setLoading((prev) => ({ ...prev, submit: false }))
      }, 2000)
    }
  }
  const propModal = () => {
    if (showModal.cancel) {
      return {
        title: 'Cancel?',
        description: `<p class="fw-bold">All data will be deleted, cancel creating ticket?</p>`,
        onCancel: () => setShowModal({ ...showModal, cancel: false }),
        onSubmit: () => handleBack()
      }
    }
    return {
      title: 'Create?',
      description: `<p class="fw-bold">Make sure to assign checker and PIC to rack properly!?</p>`,
      onCancel: () => setShowModal({ ...showModal, submit: false }),
      onSubmit: () => handleSubmit()
    }
  }
  const fetchData = async () => {
    try {
      setLoading((prev) => ({ ...prev, page: true }))
      const params = {
        warehouse_id: state?.warehouse_id || '',
        start_date: dateFormat(state?.start_time, 'YYYY-MM-DD HH:mm:ss'),
        end_date: dateFormat(state?.end_time, 'YYYY-MM-DD HH:mm:ss')
      }
      const res = await api.post('stock-opname/racks', params)
      const { data: dataResponse } = res
      if (dataResponse?.success) {
        setData(dataResponse?.data)
        setOptions({
          pics: state?.pics || [],
          checkers: state?.checkers || []
        })
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.errors?.message ||
        error?.message ||
        'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
      handleBack()
    } finally {
      setTimeout(() => {
        setLoading((prev) => ({ ...prev, page: false }))
      }, 3000)
    }
  }
  const getRackNameSelected = useMemo(() => {
    return selectedRacks?.map((item) => item?.rack_name).join(', ')
  }, [selectedRacks])
  const ModalPropMemo = useMemo(() => {
    if (showModal.submit) {
      return {
        key: 'submit',
        headerTitle: '',
        description: `<p class="fw-bold">Make sure to assign checker and PIC to rack properly!?</p>`,
        onCancel: () => setShowModal({ ...showModal, submit: false }),
        onSubmit: () => handleSubmit()
      }
    }
    if (showModal.cancel) {
      return {
        key: 'cancel',
        headerTitle: '',
        title: 'Cancel?',
        description: `<p class="fw-bold">All data will be deleted, cancel creating ticket?</p>`,
        onCancel: () => setShowModal({ ...showModal, cancel: false }),
        onSubmit: () => handleBack()
      }
    }
    if (showModal.selectPicChecker) {
      return {
        key: 'selectPicChecker',
        headerTitle: 'Select Checker and PIC',
        title: '',
        description: null,
        onCancel: () => {},
        onSubmit: () => {}
      }
    }
    return {
      key: '',
      headerTitle: '',
      title: '',
      description: '',
      onCancel: () => {},
      onSubmit: () => {}
    }
  }, [showModal])
  const handleClose = () => {
    setShowModal({
      submit: false,
      cancel: false,
      selectPicChecker: false
    })
    setSelectedForm({ pic: null, checker: null })
  }
  const handlingSavingBulk = () => {
    const selectedRackIds = selectedRacks.map((item) => item.id) || []
    setData((prev) => {
      return prev.map((item) => {
        if (selectedRackIds.includes(item.id)) {
          return {
            ...item,
            checker_id: selectedForm.checker,
            pic_id: selectedForm.pic
          }
        }
        return item
      })
    })
    setSelectedRacks([])
    handleClose()
  }
  useEffect(() => {
    fetchData()
  }, [state])
  if (loading.page) {
    return <Loading />
  }
  return (
    <>
      <Toaster />
      <Container fluid className="px-4">
        <Row className="mb-4 align-items-center">
          <Col md={12}>
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h3 style={headerTitleStyle}>Cycle Count</h3>
              </div>
              <div className="d-flex gap-2 justify-content-end align-items-center">
                <div className="d-flex align-items-center justify-content-center me-3">
                  <p className="text-danger fw-bold mb-0">
                    Please select checker and PIC to create ticket
                  </p>
                </div>
                <Button
                  variant="light"
                  className="text-secondary fw-bold px-3 border"
                  onClick={() =>
                    setShowModal({
                      ...showModal,
                      cancel: true
                    })
                  }
                >
                  Cancel
                </Button>
                <Button
                  variant="transparent"
                  className={`btn-primary-orange fw-bold px-4 ${
                    data?.some?.((item) => !item?.checker_id || !item?.pic_id)
                      ? 'opacity-25 cursor-not-allowed'
                      : ''
                  }`}
                  disabled={data?.some?.(
                    (item) => !item?.checker_id || !item?.pic_id
                  )}
                  onClick={() =>
                    setShowModal({
                      ...showModal,
                      submit: true
                    })
                  }
                >
                  Create Ticket
                </Button>
              </div>
            </div>
          </Col>
        </Row>
        <Card style={cardStyle}>
          <Row>
            <Col md={12}>
              {selectedRacks?.length > 0 && (
                <Row>
                  <Col md={12} className="mb-3">
                    <div className="d-flex gap-3 align-items-center">
                      <p className="fw-bold mb-0">
                        {selectedRacks?.length} Rack Selected
                      </p>
                      <div
                        style={{
                          height: '16px',
                          width: '2px',
                          backgroundColor: '#dee2e6'
                        }}
                      />
                      <button
                        className="border-0 bg-transparent p-0"
                        onClick={() =>
                          setShowModal({ ...showModal, selectPicChecker: true })
                        }
                      >
                        <div className="d-flex gap-2 align-items-center">
                          <div
                            className="d-flex align-items-center justify-content-center rounded"
                            style={{
                              width: '24px',
                              height: '24px',
                              backgroundColor: 'rgba(248, 157, 29, 0.1)'
                            }}
                          >
                            <Plus
                              size={12}
                              style={{
                                color: 'var(--primary-orange)'
                              }}
                            />
                          </div>
                          <span
                            className="fw-bold"
                            style={{ color: 'var(--primary-orange)' }}
                          >
                            Select Checker and PIC
                          </span>
                        </div>
                      </button>
                    </div>
                  </Col>
                </Row>
              )}
              <Table
                hover
                responsive
                style={{
                  borderRadius: '8px',
                  overflow: 'hidden',
                  fontSize: '0.9rem'
                }}
              >
                <thead>
                  <tr>
                    {columns.map((column) => {
                      return column.key !== 'checkbox' ? (
                        <th
                          className={`align-middle p-2 ${column.className || ''}`}
                          key={column.key}
                          style={tableHeaderStyle}
                        >
                          <span>{column.label}</span>
                        </th>
                      ) : (
                        <th
                          className={`align-middle p-1 ${column.className || ''}`}
                          key={column.key}
                          style={{ ...tableHeaderStyle, width: '50px' }}
                        >
                          <div className="d-flex justify-content-center">
                            <input
                              type="checkbox"
                              role="button"
                              className="staging-area form-check-input"
                              onChange={() => handleCheckbox()}
                              style={{ cursor: 'pointer' }}
                              checked={
                                data?.length > 0 &&
                                selectedRacks?.length === data?.length
                              }
                            />
                          </div>
                        </th>
                      )
                    })}
                  </tr>
                </thead>
                <tbody>
                  {!data?.length && (
                    <tr key={`not-found-${Math.random()}`}>
                      <td colSpan={columns.length} className="text-center p-4">
                        Data not found
                      </td>
                    </tr>
                  )}
                  {data?.length > 0 &&
                    data?.map((item, index) => (
                      <tr key={`${item.id}-${index}`}>
                        {columns.map((column) => (
                          <td
                            key={column.key}
                            className={`align-middle p-1 ${
                              column.className || ''
                            }`}
                          >
                            {column.component && column.component(item)}
                            {!column.component && item[column.key]}
                          </td>
                        ))}
                      </tr>
                    ))}
                </tbody>
              </Table>
              <div className="mt-3">
                <p className="mb-0">
                  <span className="fw-bold">Total Layer:</span>
                  <span className="fw-bold text-danger ms-2">
                    {data?.length ?? 0}
                  </span>
                </p>
              </div>
            </Col>
          </Row>
        </Card>
        <ModalStockAdjustment
          show={showModal?.[ModalPropMemo.key]}
          onHide={handleClose}
          title={ModalPropMemo.headerTitle}
          size="md"
          backdrop="static"
        >
          <Modal.Body className="my-2">
            {ModalPropMemo.key !== 'selectPicChecker' ? (
              <>
                <div className="d-flex justify-content-center">
                  <svg
                    width="181"
                    height="180"
                    viewBox="0 0 181 180"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M90.5 0C40.7991 0 0.5 40.2991 0.5 90C0.5 139.701 40.7991 180 90.5 180C140.201 180 180.5 139.701 180.5 90C180.5 40.2991 140.201 0 90.5 0ZM90.5 164.732C49.2366 164.732 15.7679 131.263 15.7679 90C15.7679 48.7366 49.2366 15.2679 90.5 15.2679C131.763 15.2679 165.232 48.7366 165.232 90C165.232 131.263 131.763 164.732 90.5 164.732Z"
                      fill="#828282"
                    />
                    <path
                      d="M80.8574 125.357C80.8574 127.915 81.8734 130.367 83.6817 132.176C85.4901 133.984 87.9428 135 90.5003 135C93.0577 135 95.5104 133.984 97.3188 132.176C99.1272 130.367 100.143 127.915 100.143 125.357C100.143 122.8 99.1272 120.347 97.3188 118.539C95.5104 116.73 93.0577 115.714 90.5003 115.714C87.9428 115.714 85.4901 116.73 83.6817 118.539C81.8734 120.347 80.8574 122.8 80.8574 125.357ZM85.6789 102.857H95.3217C96.2056 102.857 96.9289 102.134 96.9289 101.25V46.6071C96.9289 45.7232 96.2056 45 95.3217 45H85.6789C84.7949 45 84.0717 45.7232 84.0717 46.6071V101.25C84.0717 102.134 84.7949 102.857 85.6789 102.857Z"
                      fill="#828282"
                    />
                  </svg>
                </div>
                <div className="text-center my-3">
                  <p>{propModal().title}</p>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: propModal().description
                    }}
                  />
                </div>
              </>
            ) : (
              <div className="my-2 p-2 ms-2">
                <p>
                  <span className="text-muted mr-2">for </span>
                  <span className="fw-bold">{getRackNameSelected || ''}</span>
                </p>
                <SelectInput
                  id="modal-pic"
                  handleChange={(e) =>
                    setSelectedForm({ ...selectedForm, pic: e.target.value })
                  }
                  label={'PIC'}
                  options={options?.pics || []}
                  value={selectedForm?.pic || ''}
                />
                <SelectInput
                  id="modal-checker"
                  handleChange={(e) =>
                    setSelectedForm({
                      ...selectedForm,
                      checker: e.target.value
                    })
                  }
                  label={'checker'}
                  options={options?.checkers || []}
                  value={selectedForm?.checker || ''}
                />
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            {showModal.cancel && (
              <>
                <Button variant="transparent" onClick={propModal().onCancel}>
                  Continue Creating
                </Button>
                <Button
                  variant="transparent"
                  className="btn-primary-orange"
                  onClick={propModal().onSubmit}
                >
                  Cancel
                </Button>
              </>
            )}
            {showModal.submit && (
              <>
                <Button variant="transparent" onClick={propModal().onCancel}>
                  Continue Assign
                </Button>
                <Button
                  variant="transparent"
                  className={`${
                    loading.submit
                      ? 'btn-secondary opacity-25'
                      : 'btn-primary-orange'
                  }`}
                  onClick={propModal().onSubmit}
                  disabled={loading.submit}
                >
                  {loading.submit ? 'Creating...' : 'Create Ticket'}
                </Button>
              </>
            )}
            {showModal.selectPicChecker && (
              <div className="d-flex gap-2">
                <Button
                  variant="transparent"
                  className={`${
                    !selectedForm?.pic || !selectedForm?.checker
                      ? 'btn-secondary opacity-25'
                      : 'btn-primary-orange'
                  }`}
                  onClick={() => handlingSavingBulk()}
                  disabled={!selectedForm?.pic || !selectedForm?.checker}
                >
                  SAVE
                </Button>
              </div>
            )}
          </Modal.Footer>
        </ModalStockAdjustment>
      </Container>
    </>
  )
}
export default StockOpnameCycleCountCreate
